const articleList = document.getElementById('idlerambling-articles');
const title = document.getElementById('idlerambling-title');

function formatDate(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en', { month: 'short', year: 'numeric' }).format(date);
}

function articleLink(post) {
  const item = document.createElement('li');
  const link = document.createElement('a');
  link.href = post.url;
  link.textContent = post.title;
  item.append(link);

  const date = formatDate(post.publishedAt);
  if (date) {
    const metadata = document.createElement('span');
    metadata.className = 'idlerambling-date';
    metadata.textContent = date;
    item.append(metadata);
  }
  return item;
}

async function loadArchive() {
  try {
    const response = await fetch('/api/idlerambling/archive');
    if (!response.ok) throw new Error('Archive request failed');
    const publication = await response.json();
    if (publication.title) title.textContent = publication.title;
    if (!Array.isArray(publication.posts) || publication.posts.length === 0) return;

    articleList.replaceChildren(...publication.posts.map(articleLink));
  } catch {
    // The direct archive link stays visible when Substack cannot be reached.
  }
}

loadArchive();
